<template>
  <div :class="{'input-group' : bootstrapStyling}">
    <!-- Calendar Button -->
    <span v-if="calendarButton" :class="{'input-group-prepend' : bootstrapStyling}"
          class="vdp-datepicker__calendar-button" v-bind:style="{'cursor:not-allowed;' : disabled}"
          @click="showCalendar">
      <span :class="{'input-group-text' : bootstrapStyling}">
        <i :class="calendarButtonIcon">
          {{ calendarButtonIconContent }}
          <span v-if="!calendarButtonIcon">&hellip;</span>
        </i>
      </span>
    </span>
    <!-- Input -->
    <div class="relative">
      <input
          :id="id"
          :ref="refName"
          :class="computedInputClass"
          :clear-button="clearButton"
          :disabled="disabled"
          :name="name"
          :open-date="openDate"
          :placeholder="placeholder"
          :readonly="!typeable"
          :required="required"
          :type="inline ? 'hidden' : 'text'"
          :value="formattedValue"
          autocomplete="off"
          class="input cursor-pointer"
          @blur="inputBlurred"
          @click="showCalendar"
          @keyup="parseTypedDate"
      >
      <div class="btn h-full w-16 absolute right-0 top-0 border-l border-light-gray" @click="showCalendar">
        <svg class="mx-auto" fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M17.6562 1.5625H16.7188V0H15.1562V1.5625H4.84375V0H3.28125V1.5625H2.34375C1.05141 1.5625 0 2.61391 0 3.90625V17.6562C0 18.9486 1.05141 20 2.34375 20H17.6562C18.9486 20 20 18.9486 20 17.6562V3.90625C20 2.61391 18.9486 1.5625 17.6562 1.5625ZM18.4375 17.6562C18.4375 18.087 18.087 18.4375 17.6562 18.4375H2.34375C1.91297 18.4375 1.5625 18.087 1.5625 17.6562V7.34375H18.4375V17.6562ZM18.4375 5.78125H1.5625V3.90625C1.5625 3.47547 1.91297 3.125 2.34375 3.125H3.28125V4.6875H4.84375V3.125H15.1562V4.6875H16.7188V3.125H17.6562C18.087 3.125 18.4375 3.47547 18.4375 3.90625V5.78125Z"
              fill="black"/>
          <path d="M4.53125 8.98438H2.96875V10.5469H4.53125V8.98438Z" fill="black"/>
          <path d="M7.65625 8.98438H6.09375V10.5469H7.65625V8.98438Z" fill="black"/>
          <path d="M10.7812 8.98438H9.21875V10.5469H10.7812V8.98438Z" fill="black"/>
          <path d="M13.9062 8.98438H12.3438V10.5469H13.9062V8.98438Z" fill="black"/>
          <path d="M17.0312 8.98438H15.4688V10.5469H17.0312V8.98438Z" fill="black"/>
          <path d="M4.53125 12.1094H2.96875V13.6719H4.53125V12.1094Z" fill="black"/>
          <path d="M7.65625 12.1094H6.09375V13.6719H7.65625V12.1094Z" fill="black"/>
          <path d="M10.7812 12.1094H9.21875V13.6719H10.7812V12.1094Z" fill="black"/>
          <path d="M13.9062 12.1094H12.3438V13.6719H13.9062V12.1094Z" fill="black"/>
          <path d="M4.53125 15.2344H2.96875V16.7969H4.53125V15.2344Z" fill="black"/>
          <path d="M7.65625 15.2344H6.09375V16.7969H7.65625V15.2344Z" fill="black"/>
          <path d="M10.7812 15.2344H9.21875V16.7969H10.7812V15.2344Z" fill="black"/>
          <path d="M13.9062 15.2344H12.3438V16.7969H13.9062V15.2344Z" fill="black"/>
          <path d="M17.0312 12.1094H15.4688V13.6719H17.0312V12.1094Z" fill="black"/>
        </svg>
      </div>
    </div>
    <!-- Clear Button -->
    <span v-if="clearButton && selectedDate" :class="{'input-group-append' : bootstrapStyling}"
          class="vdp-datepicker__clear-button" @click="clearDate()">
      <span :class="{'input-group-text' : bootstrapStyling}">
        <i :class="clearButtonIcon">
          <span v-if="!clearButtonIcon">&times;</span>
        </i>
      </span>
    </span>
    <slot name="afterDateInput"></slot>
  </div>
</template>
<script>
import { makeDateUtils } from '../utils/DateUtils'

export default {
  props: {
    selectedDate             : Date,
    resetTypedDate           : [Date],
    format                   : [String, Function],
    translation              : Object,
    inline                   : Boolean,
    id                       : String,
    name                     : String,
    refName                  : String,
    openDate                 : Date,
    placeholder              : String,
    inputClass               : [String, Object, Array],
    clearButton              : Boolean,
    clearButtonIcon          : String,
    calendarButton           : Boolean,
    calendarButtonIcon       : String,
    calendarButtonIconContent: String,
    disabled                 : Boolean,
    required                 : Boolean,
    typeable                 : Boolean,
    bootstrapStyling         : Boolean,
    useUtc                   : Boolean
  },
  data () {
    const constructedDateUtils = makeDateUtils(this.useUtc)
    return {
      input    : null,
      typedDate: false,
      utils    : constructedDateUtils
    }
  },
  computed: {
    formattedValue () {
      if (!this.selectedDate) {
        return null
      }
      if (this.typedDate) {
        return this.typedDate
      }
      return typeof this.format === 'function'
          ? this.format(this.selectedDate)
          : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation)
    },

    computedInputClass () {
      if (this.bootstrapStyling) {
        if (typeof this.inputClass === 'string') {
          return [this.inputClass, 'form-control'].join(' ')
        }
        return { 'form-control': true, ...this.inputClass }
      }
      return this.inputClass
    }
  },
  watch   : {
    resetTypedDate () {
      this.typedDate = false
    }
  },
  methods : {
    showCalendar () {
      this.$emit('showCalendar')
    },
    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate (event) {
      // close calendar if escape or enter are pressed
      if ([
        27, // escape
        13 // enter
      ].includes(event.keyCode)) {
        this.input.blur()
      }

      if (this.typeable) {
        const typedDate = Date.parse(this.input.value)
        if (!isNaN(typedDate)) {
          this.typedDate = this.input.value
          this.$emit('typedDate', new Date(this.typedDate))
        }
      }
    },
    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred () {
      if (this.typeable && isNaN(Date.parse(this.input.value))) {
        this.clearDate()
        this.input.value = null
        this.typedDate = null
      }

      this.$emit('closeCalendar')
    },
    /**
     * emit a clearDate event
     */
    clearDate () {
      this.$emit('clearDate')
    }
  },
  mounted () {
    this.input = this.$el.querySelector('input')
  }
}
// eslint-disable-next-line

</script>
